import styled from 'styled-components';

export const BriefingsDetailsStyle = styled.div`
  .content-briefings-details {
    svg.status-briefing {
      max-width: 1250px;
      width: 80%;
      display: block;
      margin: 30px auto;
      enable-background:new 0 0 973.31 73.52;
    
      .st0{display:none;}
      .st1{display:inline;}
      .st2{font-family:'Arial';}
      .st3{font-size:12px;}
      .st4{fill:#FF013E;}
      .st5{fill:#5E5E5E;}
      .st6{font-family:'Arial';}
      .st7{fill:#FFFFFF;}
      .st8{font-size:22.8099px;}
      .st9{font-size:21.1523px;}
      .st10{fill:#666666;}
      .st11{font-size:21.8501px;}
      .st12{fill:none;}
      .st13{font-size:22.7451px;}
      .st14{font-size:22.4161px;}
      .st15{font-size:22.2188px;}
      .st16{font-size:23.0073px;}
      
      #circle1,
      #circle2,
      #circle3,
      #circle4,
      #circle5,
      #circle6,
      #circle7,
      #circle8 {
        cursor: pointer;
        
        &:hover {
          circle {
            fill: #ffffff;
            stroke: #FF013E;
            stroke-width: 2px;
          }
          
          text.content-text {
            fill: #FF013E;
          }
        }
      }
      
      @media screen and (max-width: 1366px) {
        max-width: 1000px;
      }
      
      @media screen and (max-width: 480px) {
        display: none; 
      }
    }
    
    .container-begin-briefing {
       img.status {
          max-width: 90px;
          display: none;
          margin: 40px auto 30px;
        
          @media screen and (max-width: 480px) {
            display: block; 
          }  
        }
        
        .container-fluid {
          padding: 0 27px;
        }
    }
    
    @media screen and (max-width: 760px) {
      padding-left: 57px;
    }
    
    h2.content-title {
      font-family: Poppins, Heltica, Arial, sans-serif;
      background-color: #FFFFFF;
      font-size: 2.5em;
      padding: 15px 14px;
    }
    
    a.back-briefings {
      display: block;
      font-family: Poppins, Heltica, Arial, sans-serif;
      font-size: 1.4em;
      color: #FFFFFF !important;  
      padding: 20px 0;
      text-decoration: none;
      
      &:hover {
        opacity: .7;
      }
    }
    
    .box-content {
       .content-briefing {
          margin: 0;
       }
    
      .content-briefing .component-title-step {
        margin: 0 auto 30px;
      
        h3 {
          font-size: 1.6em;
        }
      }
    
      .general {
        max-width: 1250px;
        padding: 0 30px;
        margin: 30px auto;
        
        hr {
          margin: 25px 0;
        }
        
        .question p {
          font-family: Poppins, Heltica, Arial, sans-serif;
          line-height: 2.3em;
          font-size: 1.5em;
          color: #505059;
          text-align: left;
          word-wrap: break-word;
          
          &.title {
            font-family: Poppins-Medium, Heltica, Arial, sans-serif;
          } 
        }
      }
    
      .content-briefing {
        text-align: left;
        margin: 0 auto;
      }
    }
    
    .group-buttons {
      max-width: 355px;
      margin: 60px auto 0;
      display: -webkit-flex;
      display: flex;
      -webkit-justify-content: space-between;
      justify-content: space-between;
      
      .btn {
        width: 44%;
        padding: 5px 0;
        font-weight: bold;
      }
      
      .btn.btn-light {
        background-color: #FFFFFF;
        border: 2px solid #B2B2B2;
        color: #B2B2B2;
      }
      
      .btn.btn-success {
        background-color: #41C351;
    border: 2px solid #41C351;
    color: #FFFFFF;
      }
    }
  }
`;
